import MenuGroup from "aldoo-ra/MenuGroup"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import { ChevronDownIcon } from "@heroicons/react/24/outline"
import PubSub from "pubsub-js"
import SiteLanguageSelector from "../SiteLanguageSelector/button"
import DynamicSVG from "aldoo-ra/DynamicSVG"
import Value from "aldoo-ra/Value"

const HeaderMenuDesktop = () => {
  const [platform] = Value("detected_platform")

  return (
    <div className="flex w-full bg-navbar/70 flex-row h-header_height  items-center justify-between backdrop-blur-[25px] shadow-[0_0_20px_0_rgba(0,0,0,0.06)]">
      {/* Main Menu Container */}
      <div className="xl:max-w-w2_xl flex flex-row w-full items-center justify-between xl:gap-3 px-6 mx-auto">
        {/* Left Menu Group */}
        <div className="flex items-center justify-center xl:gap-3">
          {/* Logo - long */}
          <div className="lg:w-[120px] xl:w-[176px] flex-shrink-0 mt-[2px]">
            <MenuGroup name="Header Logo" renderAs="hlist.icons" iconRecolor={false} />
            {/* <div>LOGO PLACEHOLDER</div> */}
          </div>

          <MenuGroup
            name="HeaderOxfordDictionary"
            renderAs="hlist"
            styleOverrides={{
              menu_item: "lg:px-[5px] xl:px-2",
            }}
            itemWidth="auto"
            menuItemRender={(item) => {
              return <Button
                variant="nav_menuitem"
                className="whitespace-nowrap"
              >
                {item.label}
              </Button>
            }}
          />

          <MenuGroup
            name="Header Features"
            renderAs="hlist"
            styleOverrides={{
              menu_item: "lg:px-[5px] xl:px-2",
            }}
            itemWidth="auto"
            menuItemRender={(item) => {
              return <Button variant="nav_menuitem">{item.label}</Button>
            }}
          />
          {/* Hide Pricing for Phase 2------------------ */}
          <MenuGroup
            name="Header Pricing"
            renderAs="hlist"
            styleOverrides={{
              menu_item: "lg:px-[5px] xl:px-2"
            }}
            itemWidth="auto"
            menuItemRender={(item) => {
              return <Button variant="nav_menuitem">{item.label}</Button>
            }}
          />

          <MenuGroup
            name="Header Products"
            renderAs="vlist.menu"
            itemWidth="456px" //Width of the open menu panel
            rootItemRender={(item) => {
                return (
                <Button
                  variant="nav_menuitem"
                  className="flex items-center justify-between gap-[2px] xl:gap-1 mb-[2px] xl:mb-0 group"
                >
                  {item.label}
                  <ChevronDownIcon className="w-5 h-5 transform group-hover:rotate-180 transition-transform duration-200" />
                </Button>
                )
            }}

            menuItemRender={(item) => {
              return (
                <div className="flex flex-col gap-[8px] mb-2">
                  <Button
                    variant="nav_menuitem"
                    className="text-left whitespace-nowrap mb-[8px]"
                  >
                    {item.label}
                  </Button>

                  <Typography variant="txt1_dim">{item.description}</Typography>
                </div>
              )
            }}
          />

          <MenuGroup
            name="Header Partners"
            renderAs="hlist"
            styleOverrides={{
              menu_item: "lg:px-[5px] xl:px-2",
            }}
            itemWidth="auto"
            menuItemRender={(item) => {
              return <Button variant="nav_menuitem">{item.label}</Button>
            }}
          />

          <MenuGroup
            name="Header Download"
            renderAs="hlist"
            styleOverrides={{
              menu_item: "my-0",
            }}
            itemWidth="150px"
            itemsAsLinks={false}
            menuItemRender={(item) => {
              const url =
                (item?.link?.[0]?.parameters &&
                  item?.link?.[0]?.parameters?.[platform]) ||
                item?.link?.[0]?.url ||
                '#'
              return (
                <Button
                  variant="secondary_s"
                  className="!h-10 lg:!text-[15px] xl:!text-[17px] !px-3 ml-[10px]"
                >
                  <a href={url} target="_blank">
                    {item?.label}
                  </a>
                </Button>
              )
            }}
          />
        </div>

        {/* Language and Profile Group */}
        <div className="flex items-center justify-center flex-shrink-0">
          <SiteLanguageSelector />

          {/* <div className="border-r border-bordered h-[25px] mr-2 xl:ml-1 xl:mr-3" /> */}

          <MenuGroup
            name="Header Profile"
            renderAs="hlist.icons"
            itemWidth="150px"
            actionMap={{
              signin: () =>
                PubSub.publish("signin", {
                  redirect: "/account",
                }),
            }}
            menuItemRender={(item) => {
              return (
                <DynamicSVG
                  url={item.image}
                  className="w-[25px] h-[25px] text-text hover:text-primary transition duration-200"
                />
              )
            }}
          />
        </div>

      </div>
    </div>
  )
}

export default HeaderMenuDesktop